import React from 'react';
import { Button, Input, Icon, Tooltip, WithTooltip } from '@abb/abb-common-ux-react';
import * as CONSTANTS from "../../utilities/Constants";
import { useTranslation } from 'react-i18next';
import * as ICONCONSTANTS from "../../utilities/IconConstants";

interface KeyCloakInitialSetupProps {
    keycloakUsername: string;
    keycloakPassword: string;
    passwordVisible: boolean;
    updateInitialSetupStatus: (status: boolean) => void;
    onKeycloakLogin: (e: React.MouseEvent) => void;
    setKeycloakUsername: (username: string) => void;
    setKeycloakPassword: (password: string) => void;
    togglePasswordVisibility: () => void;
}

const KeyCloakInitialSetup: React.FC<KeyCloakInitialSetupProps> = ({ ...props }) => {
  const { t } = useTranslation();
  return (
    <form>
      {t(CONSTANTS.KEYCLOAK_SCREEN_DISPLAY)}
      <div>{t(CONSTANTS.KEYCLOAK_MANUALLY_CONFIGURED)} <a href="#" onClick={(e) => props.updateInitialSetupStatus(true)}>{t(CONSTANTS.CLICK_HERE)} </a> {t(CONSTANTS.AVOID_SCREEN)}</div>
      <br />
      {t(CONSTANTS.ENTER_KEYCLOAK_CREDENTIALS)}<br />
      <div className="row-data-input">
        <Input
          dataType="text"
          icon="abb/user"
          label={t(CONSTANTS.KEYCLOAK_ADMIN_USERNAME)}
          className="username"
          value={props.keycloakUsername}
          onValueChange={(val) => props.setKeycloakUsername(val)}
        />
      </div>
      <div className="row-data-input">
        <Input
          dataType={props.passwordVisible ? "text" : "password"}
          icon={props.passwordVisible ? "abb/view" : "abb/hide"}
          label={t(CONSTANTS.KEYCLOAK_ADMIN_PASSWORD)}
          className="password"
          value={props.keycloakPassword}
          onValueChange={(val) => props.setKeycloakPassword(val)}
          onIconClick={(e) => props.togglePasswordVisibility()}
        />
      </div>
      <div className="row-data-input">
        <Button
          text={t(CONSTANTS.CONFIGURE_CREATE_NEW_USER_BUTTON)}
          type="primary-black"
          onClick={(e) => props.onKeycloakLogin(e)}
          shape="rounded"
        />
        <span style={{ "position": "absolute", "padding": "4px 1em" }}>
          <WithTooltip><Icon
            name={ICONCONSTANTS.ABB_INFORMATION}
            sizeClass="large"
            style={{ cursor: "pointer" }}
          /><Tooltip>
              <div>
                <b>{t(CONSTANTS.DEFAULT_USERNAME)}</b> &nbsp;: lmsuser <br />
                <b>{t(CONSTANTS.DEFAULT_PASSWORD)}</b>  &nbsp;&nbsp;: lmsuser
              </div>
            </Tooltip></WithTooltip>
        </span>
      </div>
      <p><b>{t(CONSTANTS.KEYCLOAK_NOTE)}</b> {t(CONSTANTS.KEYCLOAK_SETUP)} <a href="http://localhost:8080" target="_blank">http://localhost:8080</a> {t(CONSTANTS.KEYCLOAK_URL)}</p>
    </form>
  );
};

export default KeyCloakInitialSetup;